export default defineNuxtRouteMiddleware(async (to, from) => {
  const ALLOWED_PATHS = ["/login", "/login/select-oauth"];
  //console.log(to, from);
  if (!ALLOWED_PATHS.includes(from.path)) {
    return navigateTo("/login");
  }
  return;
});
